module.exports = __webpack_public_path__ + "assets/2464374eb48c0cd7c02579890dd598ce.mp4";